import { CodigoRespuesta } from '../../@core/enumerable/codigo-respuesta';
import { MensajeService } from '../../service/mensaje.service';
import { AutenticacionService } from '../../service/autenticacion.service';
import { Component, AfterViewInit } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-iniciar-sesion-connect',
  templateUrl: './iniciar-sesion-connect.component.html',
  styleUrls: ['./iniciar-sesion-connect.component.scss'],
})
export class IniciarSesionConnectComponent implements AfterViewInit {
  public inicioSesionForm: FormGroup;
  title = 'Iniciar sesión';

  public hide: boolean = true;
  public connectModule: boolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: AutenticacionService,
    private mensajeService: MensajeService,
    private router: Router
  ) {
    this.inicioSesionForm = this.formBuilder.group({
      Usuario: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          Validators.minLength(2),
        ]),
      ],
      Contrasena: [null, Validators.required],
    });
  }

  getErrorMessage(control: AbstractControl) {
    return control.hasError('required')
      ? 'Este campo es requerido'
      : control.hasError('email')
      ? ' El correo electrónico es inválido.'
      : control.hasError('maxlength')
      ? 'Ha excedido el máximo de caracteres permitidos'
      : control.hasError('minlength')
      ? 'Aún no ha ingresado la cantidad mínima de caracteres'
      : '';
  }

  ngAfterViewInit() {
    if (this.service.existeSesion()) {
      this.connectModule
        ? this.router.navigate(['/Connect/Remision'])
        : this.router.navigate(['/Seguimiento/Credito']);
    }

    const wicobidButton = document.getElementById('connect');
    const trackingButton = document.getElementById('tracking');
    const container = document.getElementById('container');

    wicobidButton?.addEventListener('click', () => {
      this.connectModule = true;
      this.inicioSesionForm.reset();
      container?.classList.add('right-panel-active');
    });

    trackingButton?.addEventListener('click', () => {
      this.connectModule = false;
      this.inicioSesionForm.reset();
      container?.classList.remove('right-panel-active');
    });

    const modulesCheckbox = document.getElementById('modules');
    modulesCheckbox?.addEventListener('change', (e: any) => {
      this.connectModule = !e.target.checked;
      this.connectModule
        ? container?.classList.add('right-panel-active')
        : container?.classList.remove('right-panel-active');
    });
  }

  async onSubmit(usuario: any) {
    if (this.inicioSesionForm.valid) {
      this.inicioSesionForm.disable();

      const resultado = await this.service.post(usuario).toPromise();

      if (resultado?.exito === CodigoRespuesta.Exito) {
        this.onValidateCredentials(resultado);
      } else {
        this.mensajeService.generarToastr(
          resultado?.exito,
          '',
          resultado?.mensaje
        );
      }

      this.inicioSesionForm.enable();
    }
  }

private onValidateCredentials(resultado: any) {
  const redireccionModuloConnect = () => {
    this.onCreateUserSession(resultado);
    this.router.navigate(['/Connect/Remision']);
  };

  const error = () => {
    this.mensajeService.generarToastr(
      2,
      '',
      'Su usuario no tiene permiso para acceder a esta funcionalidad'
    );
  };

  let modulo: string;

  if (resultado.dato.tienePermisoConnect && this.connectModule) {
    modulo = 'Connect';
  } else {
    modulo = 'Error';
  }

  const handleModule = {
    Connect: redireccionModuloConnect,
    Error: error,
  };

  handleModule[modulo]();
}

  private onCreateUserSession(resultado: any) {
    this.mensajeService.generarToastr(resultado.exito, '', resultado.mensaje);

    const { nombrePersonal, nombreUsuario, token } = resultado.dato.usuarioAPI;

    this.service.crearSesion(nombrePersonal, nombreUsuario, token);
  }
}
